export const products = [
  {
    id: 1,
    img: "img/react.png",
    link: "https://github.com/basantapoudel123",
  },
  {
    id: 2,
    img: "img/node.webp",
    link: "https://github.com/basantapoudel123",
  },
  {
    id: 3,
    img: "img/mongodb.png",
    link: "https://github.com/basantapoudel123",
  },
  {
    id: 4,
    img: "img/tailwind.png",
    link: "https://github.com/basantapoudel123",
  },
  {
    id: 5,
    img: "img/ts.png",
    link: "https://github.com/basantapoudel123",
  },
  {
    id: 6,
    img: "img/express.png",
    link: "https://github.com/basantapoudel123",
  },
];
